module.exports = __webpack_public_path__ + "img/bg7.b022408f.png";